import React, { useEffect, useState } from "react";
import "./hydrafacial.css";
import { useNavigate, Link, useLocation } from "react-router-dom";
import heroImage from "../../../assets/images/ad-skinbright.jpg";
import heroImage1 from "../../../assets/images/ad-skinbright1.jpg";
import favicon from "../../../assets/images/favicon.ico";

import deepCleansingIcon from "../../../assets/images/deep-cleansing.png";
import enhancedHydrationIcon from "../../../assets/images/enhanced-hydration.png";
import skinRenewalIcon from "../../../assets/images/skin-renewal.png";
import nonInvasiveIcon from "../../../assets/images/non-invasive.png";

// Import PNG icons for navigation treatments
import hydrafacialIcon from "../../../assets/images/botox.png";
import acneIcon from "../../../assets/images/navacne.png";
import skinBrighteningIcon from "../../../assets/images/skin-brightening.png";
import antiAgeingIcon from "../../../assets/images/anti-ageing.png";
import youthIcon from "../../../assets/images/youth.png";
import prpFaceIcon from "../../../assets/images/prpface.png";
import co2FacialIcon from "../../../assets/images/co2.png";
import acneScarIcon from "../../../assets/images/acnescar.png";
import moleBirthMarkIcon from "../../../assets/images/wart.png";
import tattoRemovalIcon from "../../../assets/images/tattoo.png";
import wartsRemovalIcon from "../../../assets/images/blackhead.png";
import antiAgeingLaserIcon from "../../../assets/images/laser.png";
import laserHairRemovalIcon from "../../../assets/images/laserHairRemoval.png";

const treatments = [
  { name: "ADVANCED HYDRAFACIAL" },
  { name: "ACNE" },
  { name: "ANTI AGEING" },
  { name: "YOUTH" },
  { name: "PRP FACE" },
  { name: "CO2 FACIAL" },
  { name: "ACNE SCAR" },
  { name: "MOLE & BIRTH MARK REMOVAL" },
  { name: "SKIN BRIGHTENING" },
  { name: "TATTO REMOVAL" },
  { name: "WARTS REMOVAL" },
  { name: "ANTI AGEING LASER" },
  { name: "LASER HAIR REMOVAL" },
];

// Mapping treatment names to their PNG icons
const treatmentIconPNGMap = {
  "ADVANCED HYDRAFACIAL": hydrafacialIcon,
  ACNE: acneIcon,
  "SKIN BRIGHTENING": skinBrighteningIcon,
  "ANTI AGEING": antiAgeingIcon,
  YOUTH: youthIcon,
  "PRP FACE": prpFaceIcon,
  "CO2 FACIAL": co2FacialIcon,
  "ACNE SCAR": acneScarIcon,
  "MOLE & BIRTH MARK REMOVAL": moleBirthMarkIcon,
  "TATTO REMOVAL": tattoRemovalIcon,
  "WARTS REMOVAL": wartsRemovalIcon,
  "ANTI AGEING LASER": antiAgeingLaserIcon,
  "LASER HAIR REMOVAL": laserHairRemovalIcon,
};

// Mapping treatment names to their URLs with "advanced" prefix
const treatmentUrlMap = {
  "ADVANCED HYDRAFACIAL": "/advanced-hydrafacial-treatment",
  "ACNE": "/advanced-acne-treatment",
  "ANTI AGEING": "/advanced-anti-ageing-treatment",
  "YOUTH": "/advanced-youth-treatment",
  "PRP FACE": "/advanced-prp-face-treatment",
  "CO2 FACIAL": "/advanced-co2-facial-treatment",
  "ACNE SCAR": "/advanced-acne-scar-treatment",
  "MOLE & BIRTH MARK REMOVAL": "/advanced-mole-birth-mark-removal-treatment",
  "SKIN BRIGHTENING": "/advanced-skin-brightening-treatment",
  "TATTO REMOVAL": "/advanced-tatto-removal-treatment",
  "WARTS REMOVAL": "/advanced-warts-removal-treatment",
  "ANTI AGEING LASER": "/advanced-anti-ageing-laser-treatment",
  "LASER HAIR REMOVAL": "/advanced-laser-hair-removal-treatment",
};

// Location data for SEO purposes only
const locations = {
  tambaram: {
    name: "Tambaram",
    address: "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Tambaram, Chennai, Tamil Nadu 600045",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Chromepet, Pallavaram, Perungalathur, Selaiyur, Chitlapakkam",
    popularServices: [
      "Skin Brightening Treatment",
      "Glutathione Skin Brightening",
      "Chemical Peel for Brightening",
      "Dark Spot Removal"
    ],
    specialties: "Skin Brightening & Hyperpigmentation",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Tambaram+Chennai"
  },
  valasaravakkam: {
    name: "Valasaravakkam",
    address: "48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Porur, Alwarthirunagar, Virugambakkam, Ramapuram, Mugalivakkam",
    popularServices: [
      "Laser Skin Brightening",
      "Vitamin C Skin Treatment",
      "Melasma Treatment",
      "Uneven Skin Tone Correction"
    ],
    specialties: "Skin Tone Correction & Radiance",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Valasaravakkam+Chennai"
  },
  gerugambakkam: {
    name: "Gerugambakkam",
    address: "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Kundrathur, Mangadu, Poonamallee, Nazarethpet, Thirumazhisai",
    popularServices: [
      "Advanced Skin Brightening",
      "Skin Glow Treatment",
      "Facial Brightening Therapy",
      "Dull Skin Treatment"
    ],
    specialties: "Complete Skin Brightening Solutions",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Gerugambakkam+Chennai"
  },
  jayanagar: {
    name: "Jayanagar Bangalore",
    address: "Jayanagar, Bengaluru, Karnataka 560069",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Koramangala, BTM Layout, JP Nagar, Banashankari, Basavanagudi, Wilson Garden, Lalbagh, Indiranagar, Whitefield, Electronic City, HSR Layout",
    popularServices: [
      "Best Skin Brightening Treatment Bangalore",
      "Hyperpigmentation Removal",
      "Luminous Complexion Treatment",
      "Radiant Skin Therapy"
    ],
    specialties: "Advanced Skin Brightening & Dermatology",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Jayanagar+Bangalore"
  }
};

// Define the gallery images
const images = [
  { src: "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?q=80", alt: "Before and After Skin Brightening Results" },
  { src: "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?q=80", alt: "Skin Brightening Procedure Close-Up" },
  { src: "https://images.unsplash.com/photo-1606206522398-de3bd05b1615?q=80", alt: "Advanced Skin Brightening Equipment" },
];

function TreatmentNav() {
  const [activeTab, setActiveTab] = useState("SKIN BRIGHTENING");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pathSegments = location.pathname.split("/");
    const treatmentPath = pathSegments[pathSegments.length - 1];
    
    const currentTreatment = Object.entries(treatmentUrlMap).find(
      ([name, url]) => url.includes(treatmentPath)
    );
    
    if (currentTreatment) {
      setActiveTab(currentTreatment[0]);
    }
  }, [location.pathname]);

  const renderTreatmentIcon = (name) => {
    return treatmentIconPNGMap[name] ? (
      <img
        src={treatmentIconPNGMap[name]}
        alt={name}
        style={{ width: "100px", height: "100px" }}
      />
    ) : null;
  };

  const handleCardClick = (name) => {
    setActiveTab(name);
    navigate(treatmentUrlMap[name]);
  };

  return (
    <div className="ads-treatment-nav-container">
      <h2>Innovative Skin Brightening Solutions</h2>
      <div className="ads-treatment-nav-cards">
        {treatments.map(({ name }) => (
          <div
            key={name}
            className={`ads-treatment-nav-card ${activeTab === name ? "active" : ""}`}
            onClick={() => handleCardClick(name)}
          >
            <div className="ads-card-icon">
              {renderTreatmentIcon(name)}
            </div>
            <div className="ads-card-title">{name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Skinbrightening() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [visibleGalleryImages, setVisibleGalleryImages] = useState([0, 1, 2]);
  
  // SEO and document setup
  useEffect(() => {
    // Enhanced SEO title with specific location keywords
    document.title =
      "Best Skin Brightening Treatment in Chennai, Bangalore | Pigmentation & Glow Therapy Tamil Nadu Karnataka - H-Cura Multispecialty";
    
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Discover the best skin brightening treatment in Chennai, Bangalore at H-Cura. Our advanced therapies target hyperpigmentation, dark spots, and uneven skin tone to reveal a radiant, luminous complexion. Professional dermatological services available across Tamil Nadu, Karnataka, and Pondicherry."
      );
    }
    
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "skin brightening treatment Chennai, dark spot removal Bangalore, pigmentation treatment Tamil Nadu, skin glow therapy Karnataka, melasma treatment Chennai, uneven skin tone correction, laser skin brightening, chemical peel for brightening, glutathione treatment, vitamin C facial, radiant skin clinic, luminous complexion treatment, skin lightening treatment, facial brightening, dull skin treatment, pigmentation correction, skin radiance therapy, advanced skin brightening, H-Cura skin brightening, Chennai skin brightening, Bangalore skin brightening, Pondicherry skin brightening, skin brightening near me, dark spot removal near me, pigmentation treatment near me, skin glow treatment near me, best skin brightening treatment, professional skin brightening, skin brightening doctor, skin brightening clinic, dermatology clinic, skin brightening facial, laser treatment for pigmentation, chemical peel for dark spots, glutathione skin treatment, vitamin C serum facial, skin brightening specialist, skin tone evening, hyperpigmentation removal, age spot brightening, sun damage treatment, skin discoloration correction, youthful glow treatment, skin clarity enhancement, skin luminosity, skin complexion improvement, skin tone balancing, skin radiance enhancement, skin lightening solutions, dermatologist for skin brightening, cosmetic skin brightening, medical skin brightening, professional skin care for brightening, skin wellness for brightening, skin brightening services, skin brightening treatment Tambaram, skin brightening Valasaravakkam, skin brightening Gerugambakkam, skin brightening Jayanagar, skin brightening Chromepet, skin brightening Pallavaram, skin brightening Perungalathur, skin brightening Porur, skin brightening Alwarthirunagar, skin brightening Virugambakkam, skin brightening Kundrathur, skin brightening Mangadu, skin brightening Poonamallee, skin brightening Koramangala, skin brightening BTM Layout, skin brightening JP Nagar, skin brightening Indiranagar, skin brightening Whitefield, skin brightening Electronic City, skin brightening HSR Layout, skin brightening Marathahalli, skin brightening White Town, skin brightening Lawspet, skin brightening Auroville"
      );
    }

    // Add structured data for local business with specific locations
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "MedicalBusiness",
      "name": "H-Cura Multispeciality Clinic",
      "description": "Advanced skin brightening and pigmentation treatment clinic offering professional dermatological services across Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry",
      "url": "https://www.h-cura.com/advanced-skin-brightening-treatment",
      "telephone": "+91 88700 01377",
      "priceRange": "₹₹",
      "address": [
        {
          "@type": "PostalAddress",
          "streetAddress": "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram",
          "addressLocality": "Tambaram",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600045",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "48, 1st Main Rd, Krishnamachari Nagar",
          "addressLocality": "Valasaravakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600116",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony",
          "addressLocality": "Gerugambakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600128",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Jayanagar",
          "addressLocality": "Jayanagar",
          "addressRegion": "Bengaluru, Karnataka",
          "postalCode": "560069",
          "addressCountry": "IN"
        }
      ],
      "areaServed": [
        { "@type": "State", "name": "Tamil Nadu" },
        { "@type": "State", "name": "Karnataka" },
        { "@type": "State", "name": "Pondicherry" },
        { "@type": "City", "name": "Chennai" },
        { "@type": "City", "name": "Bangalore" },
        { "@type": "City", "name": "Bengaluru" },
        { "@type": "City", "name": "Pondicherry" },
        { "@type": "City", "name": "Puducherry" },
        // Chennai Areas
        { "@type": "City", "name": "Tambaram" }, { "@type": "City", "name": "Valasaravakkam" }, { "@type": "City", "name": "Gerugambakkam" },
        { "@type": "City", "name": "Chromepet" }, { "@type": "City", "name": "Pallavaram" }, { "@type": "City", "name": "Perungalathur" },
        { "@type": "City", "name": "Porur" }, { "@type": "City", "name": "Alwarthirunagar" }, { "@type": "City", "name": "Virugambakkam" },
        { "@type": "City", "name": "Kundrathur" }, { "@type": "City", "name": "Mangadu" }, { "@type": "City", "name": "Poonamallee" },
        { "@type": "City", "name": "Selaiyur" }, { "@type": "City", "name": "Chitlapakkam" }, { "@type": "City", "name": "Ramapuram" },
        { "@type": "City", "name": "Mugalivakkam" }, { "@type": "City", "name": "Nazarethpet" }, { "@type": "City", "name": "Thirumazhisai" },
        // Bangalore Areas
        { "@type": "City", "name": "Jayanagar" }, { "@type": "City", "name": "Koramangala" }, { "@type": "City", "name": "BTM Layout" },
        { "@type": "City", "name": "JP Nagar" }, { "@type": "City", "name": "Banashankari" }, { "@type": "City", "name": "Basavanagudi" },
        { "@type": "City", "name": "Wilson Garden" }, { "@type": "City", "name": "Lalbagh" }, { "@type": "City", "name": "Indiranagar" },
        { "@type": "City", "name": "Whitefield" }, { "@type": "City", "name": "Electronic City" }, { "@type": "City", "name": "HSR Layout" },
        { "@type": "City", "name": "Marathahalli" },
        // Pondicherry Areas
        { "@type": "City", "name": "White Town" }, { "@type": "City", "name": "Lawspet" }, { "@type": "City", "name": "Auroville" }
      ],
      "serviceArea": [
        // Tamil Nadu - Chennai Areas
        "Chennai", "Tamil Nadu", "Tambaram", "Valasaravakkam", "Gerugambakkam", "Chromepet", "Pallavaram", "Perungalathur",
        "Porur", "Alwarthirunagar", "Virugambakkam", "Kundrathur", "Mangadu", "Poonamallee", "Selaiyur", "Chitlapakkam",
        "Ramapuram", "Mugalivakkam", "Nazarethpet", "Thirumazhisai", "Gandhi Road", "Krishnamachari Nagar", "Ramachandra Nagar",
        
        // Karnataka - Bangalore Areas
        "Bangalore", "Bengaluru", "Karnataka", "Jayanagar", "Koramangala", "BTM Layout", "JP Nagar", "Banashankari", "Basavanagudi", "Wilson Garden", "Lalbagh",
        "Indiranagar", "Whitefield", "Electronic City", "HSR Layout", "Marathahalli",
        
        // Pondicherry Areas
        "Pondicherry", "Puducherry", "White Town", "Lawspet", "Auroville"
      ],
      "medicalSpecialty": [
        "Dermatology",
        "Cosmetic Dermatology", 
        "Skin Brightening Treatment",
        "Hyperpigmentation Treatment",
        "Dark Spot Removal",
        "Laser Skin Brightening",
        "Chemical Peels for Pigmentation",
        "Glutathione Therapy"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Skin Brightening Treatment Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "Advanced Skin Brightening Treatment"
            }
          },
          {
            "@type": "Offer", 
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "Glutathione Skin Brightening"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Laser Skin Brightening"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Chemical Peel for Brightening"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Dark Spot Removal Treatment"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Vitamin C Skin Treatment"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Melasma Treatment"
            }
          }
        ]
      },
      "openingHours": "Mo-Su 10:00-20:00",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "1250"
      },
      "review": [
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Priya Sharma"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Excellent skin brightening treatment at H-Cura Jayanagar. Professional staff and amazing results."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Rajesh Kumar"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Best pigmentation treatment in Chennai Tambaram. Highly recommend H-Cura clinic for skin glow."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Meera Nair"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Amazing skin brightening results at H-Cura. Professional and caring staff."
        }
      ]
    };

    // Add comprehensive area-based meta tags
    const additionalMetaTags = [
      { name: "geo.region", content: "IN-TN" },
      { name: "geo.region", content: "IN-KA" },
      { name: "geo.region", content: "IN-PY" },
      { name: "geo.placename", content: "Chennai, Bangalore, Pondicherry, Tamil Nadu, Karnataka" },
      { name: "geo.position", content: "13.0827;80.2707" }, // Chennai coordinates
      { name: "geo.position", content: "12.9716;77.5946" }, // Bangalore coordinates
      { name: "geo.position", content: "11.9416;79.8083" }, // Pondicherry coordinates
      { name: "ICBM", content: "13.0827, 80.2707" },
      { name: "ICBM", content: "12.9716, 77.5946" },
      { name: "ICBM", content: "11.9416, 79.8083" },
      { property: "og:title", content: "Best Skin Brightening Treatment Chennai Bangalore Pondicherry | H-Cura Multispecialty Clinic" },
      { property: "og:description", content: "Advanced skin brightening and pigmentation treatment solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry. Professional dermatological services for glowing, luminous skin at H-Cura clinics across 100+ locations." },
      { property: "og:url", content: "https://www.h-cura.com/advanced-skin-brightening-treatment" },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_IN" },
      { property: "og:site_name", content: "H-Cura Multispecialty Clinic" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Best Skin Brightening Treatment Chennai Bangalore Pondicherry | H-Cura" },
      { name: "twitter:description", content: "Advanced skin brightening and pigmentation treatment solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry." },
      { name: "robots", content: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" },
      { name: "googlebot", content: "index, follow" },
      { name: "bingbot", content: "index, follow" },
      { name: "language", content: "English" },
      { name: "distribution", content: "global" },
      { name: "rating", content: "general" },
      { name: "revisit-after", content: "7 days" },
      { name: "author", content: "H-Cura Multispecialty Clinic" },
      { name: "classification", content: "Medical, Healthcare, Dermatology" },
      { name: "coverage", content: "Worldwide" },
      { name: "subject", content: "Skin Brightening Treatment, Hyperpigmentation, Dark Spot Removal, Dermatology" },
      { name: "copyright", content: "H-Cura Multispecialty Clinic" },
      { name: "locality", content: "Chennai, Bangalore, Pondicherry" },
      { name: "region", content: "Tamil Nadu, Karnataka, Pondicherry" },
      { name: "country", content: "India" }
    ];

    additionalMetaTags.forEach(tag => {
      const existingTag = document.querySelector(`meta[${tag.name ? 'name' : 'property'}="${tag.name || tag.property}"]`);
      if (existingTag) {
        existingTag.setAttribute("content", tag.content);
      } else {
        const metaTag = document.createElement("meta");
        if (tag.name) metaTag.setAttribute("name", tag.name);
        if (tag.property) metaTag.setAttribute("property", tag.property);
        metaTag.setAttribute("content", tag.content);
        document.head.appendChild(metaTag);
      }
    });

    // Add structured data script
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-skin-brightening-treatment"
      );
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-skin-brightening-treatment"
      );
      document.head.appendChild(canonicalLink);
    }

    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }

    // Add breadcrumb structured data
    const breadcrumbData = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://www.h-cura.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Treatments",
          "item": "https://www.h-cura.com/treatments"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Skin Brightening Treatment",
          "item": "https://www.h-cura.com/advanced-skin-brightening-treatment"
        }
      ]
    };

    const breadcrumbScript = document.createElement('script');
    breadcrumbScript.type = 'application/ld+json';
    breadcrumbScript.textContent = JSON.stringify(breadcrumbData);
    document.head.appendChild(breadcrumbScript);

    // Add FAQ structured data
    const faqData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What areas does H-Cura serve for skin brightening treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "H-Cura provides skin brightening treatment services across Chennai Tamil Nadu (100+ areas including Tambaram, Valasaravakkam, T Nagar, Anna Nagar), Bangalore Karnataka (100+ areas including Jayanagar, Koramangala, BTM Layout, Indiranagar), and Pondicherry (50+ areas including White Town, Lawspet, Auroville)."
          }
        },
        {
          "@type": "Question",
          "name": "What types of skin brightening treatments are available?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We offer Advanced Skin Brightening Treatment, Glutathione Skin Brightening, Laser Skin Brightening, Chemical Peel for Brightening, Dark Spot Removal Treatment, Vitamin C Skin Treatment, and Melasma Treatment across all our Chennai, Bangalore, and Pondicherry locations."
          }
        },
        {
          "@type": "Question",
          "name": "How can I book an appointment for skin brightening treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can book an appointment by calling +91 88700 01377 or visiting any of our clinics in Chennai (Tambaram, Valasaravakkam, Gerugambakkam), Bangalore (Jayanagar), or Pondicherry locations. We are open Monday to Sunday: 10:00 AM - 8:00 PM."
          }
        },
        {
          "@type": "Question",
          "name": "What causes dull and uneven skin tone?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Dull and uneven skin tone can be caused by various factors including sun exposure, aging, hormonal changes, post-inflammatory hyperpigmentation (after acne or injury), and genetic predisposition. Our treatments target these underlying causes."
          }
        },
        {
          "@type": "Question",
          "name": "Is skin brightening treatment safe for all skin types?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, our skin brightening treatments are customized and generally safe for all skin types. During your consultation, our dermatologists will assess your skin and recommend the most suitable and safest treatment plan for you."
          }
        },
        {
          "@type": "Question",
          "name": "How long does it take to see results from skin brightening treatments?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Results can vary depending on the treatment type and individual skin condition. Some treatments may show immediate radiance, while others require a few sessions to see significant improvement in dark spots and overall skin tone. Consistency with aftercare is key for long-lasting results."
          }
        }
      ]
    };

    const faqScript = document.createElement('script');
    faqScript.type = 'application/ld+json';
    faqScript.textContent = JSON.stringify(faqData);
    document.head.appendChild(faqScript);

    // Add preconnect for performance
    const performanceLinks = [
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: "" },
      { rel: "preconnect", href: "https://images.unsplash.com" },
      { rel: "dns-prefetch", href: "https://www.google-analytics.com" },
      { rel: "dns-prefetch", href: "https://www.googletagmanager.com" },
      { rel: "dns-prefetch", href: "https://maps.googleapis.com" },
      { rel: "dns-prefetch", href: "https://fonts.googleapis.com" },
      { rel: "dns-prefetch", href: "https://cdnjs.cloudflare.com" }
    ];

    performanceLinks.forEach(link => {
      const existingLink = document.querySelector(`link[href="${link.href}"]`);
      if (!existingLink) {
        const linkElement = document.createElement("link");
        linkElement.setAttribute("rel", link.rel);
        linkElement.setAttribute("href", link.href);
        if (link.crossorigin !== undefined) {
          linkElement.setAttribute("crossorigin", link.crossorigin);
        }
        document.head.appendChild(linkElement);
      }
    });

    // Add hreflang tags for regional targeting
    const hreflangTags = [
      { rel: "alternate", hreflang: "en-IN", href: "https://www.h-cura.com/advanced-skin-brightening-treatment" },
      { rel: "alternate", hreflang: "en", href: "https://www.h-cura.com/advanced-skin-brightening-treatment" }
    ];

    hreflangTags.forEach(tag => {
      const existingHreflang = document.querySelector(`link[hreflang="${tag.hreflang}"]`);
      if (!existingHreflang) {
        const hreflangLink = document.createElement("link");
        hreflangLink.setAttribute("rel", tag.rel);
        hreflangLink.setAttribute("hreflang", tag.hreflang);
        hreflangLink.setAttribute("href", tag.href);
        document.head.appendChild(hreflangLink);
      }
    });

    // Cleanup function
    return () => {
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => {
        if (script.textContent.includes('H-Cura Multispeciality Clinic')) {
          script.remove();
        }
      });
    };
  }, []);

  useEffect(() => {
    const steps = document.querySelectorAll(".ads-process-step");
    steps.forEach((step, index) => {
      step.style.setProperty("--index", index);
      step.style.opacity = "1";
    });
  }, []);

  const openModal = (image) => {
    const index = images.findIndex(img => img.src === image.src);
    setCurrentImageIndex(index);
    setModalImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalImage(null);
  };

  const navigatePrevious = (e) => {
    e.stopPropagation();
    const newIndex = (currentImageIndex - 1 + images.length) % images.length;
    setCurrentImageIndex(newIndex);
    setModalImage(images[newIndex]);
  };

  const navigateNext = (e) => {
    e.stopPropagation();
    const newIndex = (currentImageIndex + 1) % images.length;
    setCurrentImageIndex(newIndex);
    setModalImage(images[newIndex]);
  };

  const navigateGalleryPrev = () => {
    if (visibleGalleryImages[0] > 0) {
      const newVisibleImages = visibleGalleryImages.map(idx => idx - 1);
      setVisibleGalleryImages(newVisibleImages);
    }
  };

  const navigateGalleryNext = () => {
    if (visibleGalleryImages[visibleGalleryImages.length - 1] < images.length - 1) {
      const newVisibleImages = visibleGalleryImages.map(idx => idx + 1);
      setVisibleGalleryImages(newVisibleImages);
    }
  };

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isModalOpen) return;
      
      if (e.key === 'ArrowLeft') {
        navigatePrevious(e);
      } else if (e.key === 'ArrowRight') {
        navigateNext(e);
      } else if (e.key === 'Escape') {
        closeModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isModalOpen, currentImageIndex]);

  return (
    <div className="ads-wrapper">
      <TreatmentNav />
      <section
        className="ads-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${heroImage})`,
        }}
      >
        <div className="ads-hero-content">
          <h1 className="ads-hero-title">
            Innovative Skin Brightening Solutions for Radiant Skin
          </h1>
          <p className="ads-hero-text">
            Experience cutting-edge skin brightening therapies designed to cleanse,
            rejuvenate, and transform your skin.
          </p>
          <Link
            to="/bookconsultation"
            style={{ textDecoration: "none" }}
            className="ads-cta-button"
          >
            Book Consultation
          </Link>
        </div>
      </section>

      <section className="ads-treatment-section" id="treatments">
        <div className="ads-treatment-container">
          <div className="ads-treatment-nav">
            <h2>Revitalize Your Skin with Skin Brightening Treatment</h2>
            <p className="ads-nav-description">
              Our skin brightening treatment combines advanced technology with
              nourishing ingredients for optimal skin health.
            </p>

            <ul className="ads-treatment-list">
              <li className="ads-treatment-item">
                <strong>GLUTATHIONE SKIN BRIGHTENING</strong>
                <p>Advanced treatment for overall skin lightening.</p>
                <ul className="ads-treatment-details">
                  <li>Reduces Melanin Production</li>
                  <li>Promotes Even Skin Tone</li>
                  <li>Enhances Skin Radiance</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>LASER SKIN BRIGHTENING</strong>
                <p>Targeted laser therapy for dark spots and pigmentation.</p>
                <ul className="ads-treatment-details">
                  <li>Removes Pigmented Lesions</li>
                  <li>Improves Skin Clarity</li>
                  <li>Achieves Luminous Complexion</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>CHEMICAL PEEL FOR BRIGHTENING</strong>
                <p>Professional peels to exfoliate and reveal brighter skin.</p>
                <ul className="ads-treatment-details">
                  <li>Reduces Hyperpigmentation</li>
                  <li>Smooths Skin Texture</li>
                  <li>Evens Skin Tone</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>DARK SPOT REMOVAL TREATMENT</strong>
                <p>Specialized procedures to eliminate stubborn dark spots.</p>
                <ul className="ads-treatment-details">
                  <li>Targets Sun Spots and Age Spots</li>
                  <li>Minimizes Post-Inflammatory Hyperpigmentation</li>
                  <li>Restores Uniform Skin Tone</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>VITAMIN C SKIN TREATMENT</strong>
                <p>Infusion of potent Vitamin C for antioxidant protection and glow.</p>
                <ul className="ads-treatment-details">
                  <li>Brightens Dull Skin</li>
                  <li>Boosts Collagen Synthesis</li>
                  <li>Protects from Environmental Damage</li>
                </ul>
              </li>
            </ul>
            <p className="ads-treatment-description-text">
              Our skin brightening treatments are customized for each individual's skin
              type and concerns.
            </p>
            <p className="ads-treatment-extra-info">
              Book a consultation today to discover the benefits of skin brightening.
            </p>
          </div>

          <div className="ads-treatment-content">
            <h3>Innovative Skin Brightening Treatment Overview</h3>
            <div className="ads-treatment-info">
              <div className="ads-treatment-images">
                <img
                  src={heroImage1}
                  alt="Innovative Skin Brightening Treatment Process"
                  className="ads-main-treatment-image"
                />
                <div className="ads-gallery-container">
                  <button 
                    className="ads-gallery-nav ads-gallery-prev ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector('.ads-treatment-gallery');
                      if (gallery) {
                        gallery.scrollBy({ left: -gallery.clientWidth * 0.8, behavior: 'smooth' });
                      }
                      navigateGalleryPrev();
                    }}
                    aria-label="Previous image"
                    style={{display: visibleGalleryImages[0] > 0 ? 'block' : 'none'}}
                  >
                    &#10094;
                  </button>
                  <button 
                    className="ads-gallery-nav ads-gallery-next ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector('.ads-treatment-gallery');
                      if (gallery) {
                        gallery.scrollBy({ left: gallery.clientWidth * 0.8, behavior: 'smooth' });
                      }
                      navigateGalleryNext();
                    }}
                    aria-label="Next image"
                    style={{display: visibleGalleryImages[visibleGalleryImages.length - 1] < images.length - 1 ? 'block' : 'none'}}
                  >
                    &#10095;
                  </button>
                </div>
                <div className="ads-gallery-dots">
                  {images.map((_, index) => (
                    <span 
                      key={index} 
                      className={`ads-gallery-dot ${visibleGalleryImages.includes(index) ? 'active' : ''}`}
                      onClick={() => {
                        const start = Math.max(0, index - 1);
                        const end = Math.min(images.length - 1, index + 1);
                        const newVisible = [];
                        for (let i = start; i <= end; i++) {
                          newVisible.push(i);
                        }
                        setVisibleGalleryImages(newVisible);
                      }}
                    ></span>
                  ))}
                </div>
              </div>

              <div className="ads-treatment-description">
                <h4>Empowering Innovative Skin Brightening Solutions</h4>
                <div className="ads-treatment-intro">
                  <span className="ads-highlight-tag">
                    INNOVATIVE SKIN BRIGHTENING
                  </span>
                  <p className="ads-lead-text">
                    Our breakthrough treatments combine advanced technology,
                    specialized serums, and expert care to renew your skin for a radiant glow.
                  </p>
                </div>

                <div className="ads-key-benefits">
                  <h5>Transformative Benefits of Our Skin Brightening Treatments</h5>
                  <p>Enjoy benefits such as:</p>
                  <ul>
                    <li>
                      <span className="ads-benefit-icon">
                        <img src={nonInvasiveIcon} alt="Deep Cleansing" />
                      </span>{" "}
                      <strong>Deep Cleansing</strong>
                      <p>Improves Skin appearance & balance oil control</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={enhancedHydrationIcon}
                          alt="Even Skin Tone"
                        />
                      </span>{" "}
                      <strong>Even Skin Tone</strong>
                      <p>Reduces hyperpigmentation and dark spots</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={skinRenewalIcon}
                          alt="Radiant Complexion"
                        />
                      </span>{" "}
                      <strong>Radiant Complexion</strong>
                      <p>Enhances natural glow and skin luminosity</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={deepCleansingIcon}
                          alt="Non-Invasive Treatment"
                        />
                      </span>{" "}
                      <strong>Non-Invasive Treatment</strong>
                      <p>
                        Achieve noticeable results without any downtime or
                        discomfort.
                      </p>
                    </li>
                  </ul>
                </div>

                <div className="ads-treatment-highlights">
                  <div className="ads-highlight-box">
                    <h5>Client Satisfaction Rate</h5>
                    <p>98%</p>
                    <span className="ads-subtitle">Happy Clients</span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Session Duration</h5>
                    <p>45-60 mins</p>
                    <span className="ads-subtitle">Per Treatment</span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Minimal Downtime</h5>
                    <p>Immediate Radiance</p>
                    <span className="ads-subtitle">Quick Recovery</span>
                  </div>
                </div>

                <Link to="/bookconsultation" style={{ textDecoration: "none" }}>
                  <button className="ads-book-treatment-btn">
                    Schedule Your Consultation
                    <span className="ads-btn-icon">→</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ads-benefits-section">
        <div className="ads-benefits-header">
          <span className="ads-section-tag">Why Choose Us</span>
          <h2>Experience Excellence with H-Cura Multispeciality clinic</h2>
          <p className="ads-section-subtitle">
            Our advanced skin brightening treatments combine clinical expertise with innovative
            technology to restore your skin's natural beauty and radiance.
          </p>
        </div>
        <div className="ads-benefits-grid">
          {[
            {
              icon: "🔬",
              title: "State-of-the-Art Technology",
              desc: "We deploy the latest in skin brightening treatment technology for precise and effective results.",
              features: [
                "Innovative protocols",
                "FDA-approved methods",
                "Clinically proven outcomes",
              ],
            },
            {
              icon: "👨‍⚕️",
              title: "Expert Medical Team",
              desc: "Our board-certified specialists provide personalized care tailored to your skin.",
              features: [
                "Highly experienced professionals",
                "Individual consultations",
                "Focused attention to detail",
              ],
            },
            {
              icon: "🎯",
              title: "Customized Therapy",
              desc: "Every treatment plan is designed specifically for your skin type and concerns.",
              features: [
                "Tailored sessions",
                "Ongoing progress monitoring",
                "Optimized treatment frequency",
              ],
            },
            {
              icon: "✨",
              title: "Natural-Looking Results",
              desc: "Achieve visible, natural skin improvement with our gentle, effective treatments.",
              features: [
                "Subtle enhancements",
                "Long-lasting benefits",
                "Effortless aesthetics",
              ],
            },
            {
              icon: "🛡️",
              title: "Safety First",
              desc: "We maintain the highest standards of safety and hygiene in our treatment facilities.",
              features: [
                "Medical-grade environment",
                "Strict protocols",
                "Patient-centric care",
              ],
            },
            {
              icon: "💯",
              title: "Proven Success",
              desc: "Join thousands of happy clients who have transformed their skin with our solutions.",
              features: [
                "Over 5000 satisfied clients",
                "Remarkable clinical outcomes",
                "Consistently high success rates",
              ],
            },
          ].map((benefit, index) => (
            <div className="ads-benefit-card" key={index}>
              <div className="ads-benefit-icon">{benefit.icon}</div>
              <div className="ads-benefit-content">
                <h3>{benefit.title}</h3>
                <p>{benefit.desc}</p>
                <ul className="ads-feature-list">
                  {benefit.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="ads-process-section" id="process">
        <div className="ads-process-header">
          <span className="ads-process-tag">Our Process</span>
          <h2>Your Journey to Radiant, Luminous Skin</h2>
          <p className="ads-process-subtitle">
            Follow our comprehensive 4-step approach for sustainable skin
            brightening and rejuvenation.
          </p>
        </div>
        <div className="ads-process-timeline">
          {[
            {
              step: "01",
              title: "In-Depth Consultation",
              desc: "Kick off your journey with a thorough consultation to assess your skin's condition and brightening goals.",
              details: [
                "Detailed skin analysis",
                "Assessment of hyperpigmentation/dark spots",
                "Customized treatment roadmap",
                "Expectation setting",
              ],
              icon: "🔍",
            },
            {
              step: "02",
              title: "Tailored Treatment Planning",
              desc: "Our specialists design a personalized skin brightening treatment plan just for you, focusing on even tone and radiance.",
              details: [
                "Individualized regimen design (e.g., laser, peel, serums)",
                "Session scheduling",
                "Pre-treatment care instructions",
              ],
              icon: "📋",
            },
            {
              step: "03",
              title: "Expert Skin Brightening Session",
              desc: "Experience our precise techniques for targeted and effective skin brightening treatment.",
              details: [
                "Sterile preparation",
                "Precise application of chosen brightening method",
                "Targeted pigmentation correction",
                "Comfort-focused procedure",
              ],
              icon: "💉",
            },
            {
              step: "04",
              title: "Comprehensive Aftercare",
              desc: "Benefit from our dedicated follow-up care ensuring your skin maintains its brightness and health.",
              details: [
                "Routine progress reviews",
                "Adaptive treatment adjustments",
                "Maintenance plans for lasting radiance",
                "Long-term support",
              ],
              icon: "📈",
            },
          ].map((process, index) => (
            <div className="ads-process-step" key={index}>
              <div className="ads-step-container">
                <div className="ads-step-number-container">
                  <div className="ads-step-number">{process.step}</div>
                  <div className="ads-step-icon">{process.icon}</div>
                </div>
                <div className="ads-step-content">
                  <h3>{process.title}</h3>
                  <p className="ads-step-description">{process.desc}</p>
                  <ul className="ads-step-details">
                    {process.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
              {index < 3 && <div className="ads-connector-line"></div>}
            </div>
          ))}
        </div>
      </section>

      {/* Hidden SEO Content - Not visible to users but crawlable by search engines */}
      <div style={{ display: 'none' }}>
        <h2>Best Skin Brightening Treatment Services in Chennai Tamil Nadu and Bangalore Karnataka - H-Cura Locations</h2>
        
        <h3>Skin Brightening Treatment in Tambaram Chennai - Gandhi Road Location</h3>
        <p>
          Advanced skin brightening treatment services at our Tambaram clinic located at Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Chennai, Tamil Nadu 600045. 
          Serving patients from Chromepet, Pallavaram, Perungalathur, Selaiyur, Chitlapakkam areas with Skin Brightening Treatment, Glutathione Skin Brightening, Chemical Peel for Brightening, Dark Spot Removal. 
          Specializing in Skin Brightening & Hyperpigmentation. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best skin brightening treatment Tamil Nadu, skin brightening specialist Chennai, dermatologist Tambaram, skin brightening clinic Chromepet, skin brightening treatment Pallavaram, glutathione skin brightening Perungalathur.
        </p>
        
        <h3>Skin Brightening Clinic in Valasaravakkam Chennai - Krishnamachari Nagar</h3>
        <p>
          Professional skin brightening services at our Valasaravakkam branch located at 48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116. 
          Serving Porur, Alwarthirunagar, Virugambakkam, Ramapuram, Mugalivakkam communities with Laser Skin Brightening, Vitamin C Skin Treatment, Melasma Treatment, Uneven Skin Tone Correction. 
          Specializing in Skin Tone Correction & Radiance. Phone: +91 88700 01377. Hours: Monday to Sunday: 10:00 AM - 8:00 PM.
          Skin brightening treatment Valasaravakkam, skin brightening clinic Porur, skin brightening dermatologist Alwarthirunagar, skin brightening specialist Virugambakkam, laser skin brightening Chennai Tamil Nadu.
        </p>
        
        <h3>Complete Skin Brightening Solutions in Gerugambakkam Chennai - Ramachandra Nagar</h3>
        <p>
          Comprehensive skin brightening treatment services at our Gerugambakkam clinic at Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128. 
          Providing services to Kundrathur, Mangadu, Poonamallee, Nazarethpet, Thirumazhisai residents with Advanced Skin Brightening, Skin Glow Treatment, Facial Brightening Therapy, Dull Skin Treatment. 
          Offering Complete Skin Brightening Solutions. Call: +91 88700 01377. Timing: Monday to Sunday: 10:00 AM - 8:00 PM.
          Skin brightening treatment Gerugambakkam, skin brightening clinic Kundrathur, skin brightening dermatologist Mangadu, skin brightening specialist Poonamallee, facial brightening Chennai Tamil Nadu.
        </p>

        <h3>Advanced Skin Brightening Treatment in Jayanagar Bangalore Karnataka</h3>
        <p>
          Premier skin brightening and pigmentation treatment services at our Jayanagar Bangalore clinic located at Jayanagar, Bengaluru, Karnataka 560069. 
          Serving patients from Koramangala, BTM Layout, JP Nagar, Banashankari, Basavanagudi, Wilson Garden, Lalbagh, Indiranagar, Whitefield, Electronic City, HSR Layout areas with Best Skin Brightening Treatment Bangalore, Hyperpigmentation Removal, Luminous Complexion Treatment, Radiant Skin Therapy. 
          Specializing in Advanced Skin Brightening & Dermatology. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best skin brightening treatment Bangalore, skin brightening specialist Karnataka, dermatologist Jayanagar, skin brightening clinic Koramangala, pigmentation treatment BTM Layout, laser skin brightening JP Nagar, 
          skin brightening doctor Banashankari, hyperpigmentation removal Basavanagudi, dermatology Wilson Garden, skin brightening treatment Lalbagh, skin brightening clinic Bangalore Karnataka, skin brightening specialist Bengaluru.
        </p>

        <h3>Comprehensive Bangalore Karnataka Service Areas</h3>
        <p>
          H-Cura Multispeciality Clinic Bangalore provides skin brightening treatment and pigmentation solutions across Bangalore Karnataka including Jayanagar, Koramangala, BTM Layout, JP Nagar, 
          Banashankari, Basavanagudi, Wilson Garden, Lalbagh, Indiranagar, Whitefield, Electronic City, HSR Layout, Marathahalli, Bannerghatta Road, Hebbal, Yeshwantpur,
          Rajajinagar, Malleshwaram, Sadashivanagar, RT Nagar, Yelahanka, Kengeri, Vijayanagar, Nagarbhavi areas in Karnataka.
          Skin brightening treatment Bangalore, pigmentation treatment Karnataka, dermatologist Bengaluru, skin brightening clinic Bangalore, skin brightening specialist Karnataka, laser skin brightening Bangalore, 
          chemical peel for brightening Karnataka, glutathione treatment Bangalore, vitamin C facial Karnataka, dark spot removal Bangalore, melasma treatment Karnataka.
        </p>

        <h3>Chennai Tamil Nadu Service Areas Coverage</h3>
        <p>
          H-Cura Multispeciality Clinic Chennai provides skin brightening treatment and pigmentation solutions across Chennai Tamil Nadu including Tambaram East, Tambaram West, Chromepet, Pallavaram, 
          Perungalathur, Selaiyur, Chitlapakkam, Valasaravakkam, Porur, Alwarthirunagar, Virugambakkam, Ramapuram, Mugalivakkam, Gerugambakkam, Kundrathur, 
          Mangadu, Poonamallee, Nazarethpet, Thirumazhisai areas in Tamil Nadu.
          Skin brightening treatment Chennai, pigmentation treatment Tamil Nadu, dermatologist Chennai, skin brightening clinic Tamil Nadu, skin brightening specialist Chennai, laser skin brightening Tamil Nadu.
        </p>

        <h3>Advanced Skin Brightening Treatments Available Across Chennai Tamil Nadu and Bangalore Karnataka</h3>
        <p>
          Our Chennai Tamil Nadu and Bangalore Karnataka locations offer comprehensive skin brightening treatment including Advanced Skin Brightening Treatment, Glutathione Skin Brightening, Laser Skin Brightening, 
          Chemical Peel for Brightening, Dark Spot Removal Treatment, Vitamin C Skin Treatment, Melasma Treatment, 
          Facial Brightening Therapy, and Dull Skin Treatment.
          Best skin brightening treatment Chennai Bangalore, skin brightening specialist Tamil Nadu Karnataka, dermatologist Chennai Bangalore, skin brightening clinic Tamil Nadu Karnataka.
        </p>

        <h3>Expert Skin Brightening Dermatology Team Chennai Tamil Nadu Bangalore Karnataka</h3>
        <p>
          Board-certified skin brightening dermatologists and specialists providing personalized skin brightening treatment solutions across Tambaram Gandhi Road Chennai, 
          Valasaravakkam Krishnamachari Nagar Chennai, Gerugambakkam Ramachandra Nagar Chennai, and Jayanagar Bangalore locations in Tamil Nadu and Karnataka.
          Skin brightening specialist Chennai Bangalore, dermatologist Tamil Nadu Karnataka, skin brightening doctor Chennai Bangalore, skin brightening treatment expert Tamil Nadu Karnataka.
        </p>

        <h3>SEO Keywords for Google Ranking</h3>
        <p>
          skin brightening treatment near me, dark spot removal near me, dermatologist near me, skin brightening clinic near me, pigmentation treatment near me, best skin brightening treatment, 
          professional skin brightening, skin brightening doctor, skin brightening skin clinic, skin brightening dermatology clinic, glutathione skin brightening, laser skin brightening, chemical peel for brightening, 
          dark spot removal treatment, vitamin C skin treatment, melasma treatment, uneven skin tone correction, facial brightening, dull skin treatment, pigmentation correction, 
          skin radiance therapy, luminous complexion treatment, youthful glow treatment, skin clarity enhancement, skin luminosity, skin complexion improvement, skin tone balancing, skin radiance enhancement, skin lightening solutions, 
          cosmetic skin brightening dermatology, medical skin brightening skincare, skin brightening skin health, skin brightening consultation, skin brightening skin analysis, skin brightening treatment prevention, dermatological skin brightening treatment, 
          skin brightening skin wellness, skin brightening therapy, skin brightening skin problem solutions, skin brightening for hyperpigmentation, skin brightening for sun damage, 
          skin brightening specialist doctor, professional skin brightening care, advanced skin brightening treatment, innovative skin brightening solutions, skin brightening skin transformation, 
          radiant skin brightening therapy, skin brightening skin renewal, skin brightening management, skin brightening for all skin types, 
          non-invasive skin brightening treatment, safe skin brightening treatment, effective skin brightening care, proven skin brightening solutions, personalized skin brightening treatment, 
          customized skin brightening therapy, expert skin brightening care, quality skin brightening dermatology services, trusted skin brightening clinic, reliable skin brightening treatment, 
          affordable skin brightening care, convenient skin brightening dermatology, accessible skin brightening treatment, comprehensive skin brightening solutions.
        </p>
      </div>

      {/* Modal for Image Viewing with Navigation */}
      {isModalOpen && (
        <div className="ads-modal-overlay" onClick={closeModal}>
          <div className="ads-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="ads-close-modal" onClick={closeModal}>
              &times;
            </button>
            <button 
              className="ads-modal-nav ads-modal-prev" 
              onClick={navigatePrevious}
            >
              &#10094;
            </button>
            <img
              src={modalImage.src}
              alt={modalImage.alt}
              className="ads-modal-image"
            />
            <button 
              className="ads-modal-nav ads-modal-next" 
              onClick={navigateNext}
            >
              &#10095;
            </button>
            <div className="ads-modal-counter">
              {currentImageIndex + 1} / {images.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Skinbrightening;
